import React from 'react';
import { Box, Typography } from '@mui/material';

const ThankYouPage = () => {
  return (
    <Box style={{ padding: '20px', maxWidth: '600px', margin: 'auto', textAlign: 'center' }}>
      <Typography variant="h4" style={{ marginBottom: '20px' }}>
        Password Reset Successful!
      </Typography>
      <Typography variant="body1">
        Your new password has been sent to your registered email address. Please check your email and use the new password to log in.
      </Typography>
    </Box>
  );
};

export default ThankYouPage;